import React, {ChangeEvent, Component, FocusEvent, ReactNode} from 'react';
import {BetSlipStore} from 'app/store/BetSlipStore';
import BetSlipController from 'app/components/bet_slip/BetSlipController';
import {inject, observer} from 'mobx-react';
import {BetSlipFocus} from 'app/utils/Consts';
import {isRedLine, STATUS_OPENED, STATUS_STARTED} from 'app/lines/line_helpers';
import AmountInput from 'app/components/reusable/AmountInput';
import {isPlayMoney} from 'app/lines/isPlayMoney';
import {isDesktop, isGuest, mobileAndTabletCheck} from 'app/utils';
import I18n from 'app/i18n';
import {openAuth} from 'app/components/auth/auth';

interface BetSlipInputAmountProps {
    isWinContainer?: boolean
    betSlipStore?: BetSlipStore
    controller?: BetSlipController
}

interface BetSlipInputAmountState {
    autoFocus: boolean
}

@inject('betSlipStore', 'controller')
@observer
export default class BetSlipInputAmountContainer extends Component<BetSlipInputAmountProps, BetSlipInputAmountState> {
    constructor(props: BetSlipInputAmountProps) {
        super(props);
        this.state = {autoFocus: this.needAutoFocus};
    }

    inputAmount: React.RefObject<HTMLInputElement> = React.createRef();

    componentDidMount(): void {
        const {betSlipStore: {setFocus}, isWinContainer} = this.props;

        if (!isWinContainer) {
            setFocus(BetSlipFocus.AMOUNT);
        }
    }

    componentDidUpdate(prevProps: Readonly<BetSlipInputAmountProps>, prevState: BetSlipInputAmountState): void {
        const autoFocus = this.needAutoFocus;

        if (prevState.autoFocus !== autoFocus) {
            if (autoFocus) {
                this.setFocus();
            } else {
                this.unSetFocusAndClearInput();
            }

            this.setState({autoFocus});
        }
    }

    get needAutoFocus(): boolean {
        const {betSlipStore: {incubator2, selectedLine, showSuggestCoef}, isWinContainer} = this.props;
        const {color, status, incubator_2: selectLineIncubator2} = selectedLine;
        return !isWinContainer && (incubator2
            ? !isRedLine(color) || !showSuggestCoef
            : status === STATUS_OPENED || selectLineIncubator2 && status === STATUS_STARTED);
    }

    handleOnChange = (e: ChangeEvent<HTMLInputElement>): void => {
        const {controller, isWinContainer} = this.props;
        const newValue = e.target.value;

        if (isWinContainer) {
            controller.changeWin(newValue);
        } else {
            controller.changeAmount(newValue);
        }
    };

    setFocus = (): void => this.inputAmount.current.focus();

    handelOnFocus = (e: FocusEvent<HTMLInputElement>): void => {
        const {betSlipStore, isWinContainer} = this.props;
        const {AMOUNT, WIN} = BetSlipFocus;
        const val = e.target.value;
        e.target.value = '';
        e.target.value = val;
        betSlipStore.setFocus(isWinContainer ? WIN : AMOUNT);
        e.target.select();
    };

    clearAmountInput = (): void => this.props.controller.changeAmount('');

    unSetFocusAndClearInput = (): void => {
        this.inputAmount.current.blur();
        this.props.controller.changeAmount('');
    };

    makeBet = (): void => {
        if (isGuest()) {
            openAuth();
            return;
        }

        this.props.controller.checkAvailableAndMakeBet();
    };

    render(): ReactNode {
        const {betSlipStore: {amount, type, amountFocus, winFocus, selectedLine, netPrize}, isWinContainer} = this.props;
        const isPM = isPlayMoney(type);
        const {isCreator} = selectedLine;
        const activeContainer = isWinContainer ? winFocus : amountFocus;
        const coefClass = `${isPM ? 'pm' : ''} ${activeContainer ? 'active' : ''}`;
        const currency = isPM ? 'PM' : '$';
        const autoFocus = this.needAutoFocus && !isCreator;
        const id = isWinContainer ? 'betSlipWin' : 'betSlipSum';
        const value = isWinContainer ? netPrize : amount;
        const readOnly = !isDesktop() && mobileAndTabletCheck();

        return <AmountInput
            autoComplete="off"
            autoFocus={autoFocus}
            containerClassName="cell-box"
            id={id}
            className={`input-number ${coefClass}`}
            inputRef={this.inputAmount}
            maxLength={8}
            name={id}
            onChange={this.handleOnChange}
            onEnterClick={this.makeBet}
            onFocus={this.handelOnFocus}
            placeholder="0.00"
            readOnly={readOnly}
            step="0.01"
            type="string"
            value={value}
        >
            <label htmlFor={id} className="label-name">{isWinContainer ? I18n.t('net_prize') : I18n.t('bet_amount')}</label>
            <label htmlFor={id} className="currency-name">{currency}</label>
        </AmountInput>;
    }
}
